var FileWrapper = require('filewrapper');


var FileView = Backbone.View.extend({
    model: FileWrapper,
    tagName: 'div',
    className: 'file',
    initialize: function (options) {
        this.model.bind('uploadSuccess', this.uploadSuccess, this);
    },
    events: {
        'click a.edit': 'toggleEdit',
        'click a.delete': 'clickDelete',
        'click a.restore': 'clickRestore',
        'buttonClick .edit': 'toggleEdit',
        'buttonClick .delete': 'clickDelete',
        'buttonClick .restore': 'clickRestore',
        'buttonClick .editForm .cancel': 'toggleEdit',
        'submit .editForm': 'submitEditForm'
    },
    uploadSuccess: function () {
        if (this.localFileData) {
            this.model.cacheDataUrl(this.localFileData);
        }
    },
    renderName: function () {
        var name = this.model.desiredName();
        if (this.name) {
            this.name.text(name);
        }
        if (this.editForm) {
            this.editForm.find('.nameInput').val(name);
        }
        this.$('a.fileLink').attr('href', this.model.getUrl());
        this.$('span.documentIcon').data('DownloadURL', this.dragDownloadURL());
    },
    toggleEdit: function (e) {
        e.preventDefault();
        this.hideEditError();
        this.renderName();
        this.$el.toggleClass('edit');
        this.$('.nameInput').select().focus();
        this.trigger('toggleEdit');
    },
    clickDelete: function (e) {
        e.preventDefault();
        var button = $(e.currentTarget);
        button.addSpin();
        button.prop('disabled', true);
        this.model.remove(_.bind(function (response) {
            button.removeSpin();
            button.prop('disabled', false);
            if (!response.success) {
                var message = "";
                switch (response.message) {
                case 'auth':
                    message = 'You don’t have permission to delete this file';
                    break;
                case 'file_not_found':
                    message = 'Unknown file';
                    break;
                case 'server_error':
                    message = 'There was a problem deleting this file';
                    break;
                default:
                    message = 'There was a problem deleting this file: ' + response.message;
                    break;
                }
                this.showEditError(message);
            }
        }, this));
    },
    clickRestore: function (e) {
        e.preventDefault();
        var button = $(e.currentTarget);
        button.addSpin();
        button.prop('disabled', true);
        this.model.restore(_.bind(function (response) {
            button.removeSpin();
            button.prop('disabled', false);
            if (!response.success) {
                var message = "";
                switch (response.message) {
                case 'auth':
                    message = 'You don’t have permission to restore this file';
                    break;
                case 'file_not_found':
                    message = 'Unknown file';
                    break;
                case 'upload_limit_reached':
                    message = "Sorry, you can’t upload more than 100 MB of files";
                    break;
                case 'server_error':
                    message = 'There was a problem restoring this file';
                    break;
                default:
                    message = 'There was a problem restoring this file: ' + response.message;
                    break;
                }
                this.showEditError(message);
            }
        }, this));
    },
    submitEditForm: function (e) {
        e.preventDefault();
        this.editForm.addSpin();
        var data = this.editForm.serializeForm();
        this.hideEditError();
        this.model.edit(data, _.bind(function (response) {
            this.editForm.removeSpin();
            if (response.success) {
                this.$el.removeClass('edit');
            } else {
                var message = "";
                switch (response.message) {
                case 'auth':
                    message = 'You don’t have permission to edit this file';
                    break;
                case 'file_not_found':
                    message = 'Unknown file';
                    break;
                case 'missing_name':
                    message = 'Missing file name';
                    break;
                case 'server_error':
                    message = 'There was a problem editing this file';
                    break;
                default:
                    message = 'There was a problem editing this file: ' + response.message;
                    break;
                }
                this.showEditError(message);
            }
        }, this));
    },
    hideEditError: function () {
        this.editError.hide();
    },
    showEditError: function (text) {
        this.editError.text(text).fadeIn('fast');
    },
    renderDeleted: function () {
        this.$el.toggleClass('deleted', this.model.isDeleted());
        this.hideEditError();
    },
    renderEditForm: function () {
        var nameInput = $('<textarea class="input nameInput" name="name">');
        var editSubmit = $('<button type="submit" class="action">').append($('<span>').text('Save'));
        var editCancel = $('<button type="button" class="cancel">').append($('<span>').text('Cancel'));
        return $('<form action="" method="post" class="editForm">')
            .append($('<p class="form">').append(nameInput))
            .append($('<p class="form">').append(editSubmit).append(editCancel));
    },
    render: function (header) {
        var info = $('<div class="info">');

        var date = $('<p class="date">');
        date.text(this.model.getDate().formatFullDate());
        info.append(date);

        this.name = $('<div class="name">');
        info.append(this.name);

        this.editForm = this.renderEditForm();
        info.append(this.editForm);

        var link = $('<a class="fileLink" target="_blank">')
            .append($('<span>').text(this.model.getSize()))
            .append(' • ')
            .append($('<span>').text(this.model.getType()));
        info.append($('<p class="link">').append(link));
        this.$el.append(info);

        var preview = $('<div class="preview">');
        var previewLink = $('<a target="_blank" class="fileLink previewLink">');
        if (!this.model.isPreviewableImage()) {
            previewLink.addClass('docLink');
        }
        previewLink.append(this.renderPreview());
        preview.append(previewLink);

        this.editError = $('<p class="userError editError">');
        preview.append(this.editError);

        var actions = this.renderActions();
        preview.append(actions);

        this.$el.append(preview);

        this.rendered();

        return this;
    },
    rendered: function () {
        this.renderName();
        this.model.bind('change:deleted', this.renderDeleted, this);
        this.model.bind('change:name', function () {
            this.renderName();
        }, this);
    },
    renderActions: function () {
        var actions = $('<span class="actions">');
        if (this.model.isOwn()) {
            actions.append($('<button type="button" class="edit">').append($('<span>').text('edit')));
            actions.append($('<button type="button" class="delete">').append($('<span>').text('delete')));
            actions.append($('<button type="button" class="restore">').append($('<span>').text('restore')));
        }
        return actions;
    },
    sizeImage: function (img, dimensions) {
        img.attr({
            src: this.model.getCachedUrl(dimensions),
            width: dimensions.width,
            height: dimensions.height
        });
        img.css({
            marginTop: -dimensions.height/2,
            marginLeft: -dimensions.width/2
        });
    },
    renderPreview: function () {
        if (this.model.isPreviewableImage()) {
            var img = $('<img class="filePreview">');
            var dimensions = this.constrainDimensions(
                FileView.MAX_WIDTH,
                FileView.MAX_HEIGHT
            );
            if (dimensions) {
                this.sizeImage(img, dimensions);
            } else {
                img.attr({
                    src: this.model.getCachedUrl({width: FileView.MAX_WIDTH})
                }).one('load', _.bind(function (e) {
                    dimensions = FileView.constrainDimensions(
                        img[0].width,
                        img[0].height,
                        FileView.MAX_WIDTH,
                        FileView.MAX_HEIGHT
                    );
                    this.sizeImage(img, dimensions);
                }, this));
            }
            return img;
        } else {
            return this.docIcon();
        }
    },
    constrainDimensions: function (maxWidth, maxHeight) {
        return FileView.constrainDimensions(
            this.model.getWidth(),
            this.model.getHeight(),
            maxWidth,
            maxHeight
        );
    },
    readFileData: function () {
        var fileRead = new $.Deferred().done(_.bind(function (src) {
            this.localFileData = src;
        }, this));
        if (this.localFileData) {
            fileRead.resolve(this.localFileData);
        } else {
            var reader = new window.FileReader();
            reader.onload = function (e) {
                fileRead.resolve(e.target.result);
            };
            reader.readAsDataURL(this.model.localFile);
        }
        return fileRead.promise();
    },
    renderLocalPreview: function (className) {
        var complete = new $.Deferred();
        if (this.model.localFile && window.FileReader && this.model.isPreviewable()) {
            var img = $('<img class="unknownFilePreview">');
            if (className) {
                img.addClass(className);
            }
            var result = $('<span class="localPreview localImagePreview">').append(img);
            this.readFileData().done(_.bind(function (src) {
                img.attr('src', src);
                this.model.set('properties', {
                    width: img[0].width,
                    height: img[0].height
                });
                complete.resolve(result);
            }, this));
        } else {
            var docIcon = this.docIcon();
            complete.resolve($('<span class="localPreview docPreview">').append(docIcon));
        }
        return complete.promise();
    },
    docIcon: function () {
        var docIcon = $('<span class="documentIcon">').addClass('ext_' + this.model.getExtension());
        if (this.model.isImage()) {
            docIcon.addClass('image');
        }
        if (this.model.isText()) {
            docIcon.addClass('text');
        }
        docIcon.append($('<span class="tag">'));
        docIcon.append($('<span class="label">').text(this.model.getExtension()));
        return docIcon;
    },
    dragDownloadURL: function () {
        return [
            this.model.getType(),
            this.model.getName().replace(/:/, '-'),
            this.model.getUrl()
        ].join(':');
        
    }
}, {
    // Sync with css
    MAX_WIDTH: 250,
    MAX_HEIGHT: 150,
    constrainDimensions: function (width, height, maxWidth, maxHeight) {
        if (!width || !height) {
            return;
        }
        var newWidth, newHeight, ratio;
        if (width > height) {
            newWidth = Math.min(width, maxWidth);
            ratio = newWidth / width;
            width = newWidth;
            height = newHeight = height * ratio;
            if (height > maxHeight) {
                newHeight = maxHeight;
                ratio = newHeight / height;
                width = newWidth = newWidth * ratio;
            }
        } else {
            newHeight = Math.min(height, maxHeight);
            ratio = newHeight / height;
            height = newHeight;
            width = newWidth = width * ratio;
            if (width > maxWidth) {
                newWidth = maxWidth;
                ratio = newWidth / width;
                height = newHeight = newHeight * ratio;
            }
        }
        return {
            width: newWidth,
            height: newHeight
        };
    },
});

module.exports = FileView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/fileview.js
// module id = 6AFE
// module chunks = 1